import '../filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.ReplyFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  template: JST["backbone/templates/monitoring/filters/reply/reply_filter"]

  events:
    'click .apply': 'apply'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @source = @options.source
    @type = @options.type

  render: ->
    @$el.html(@template(source: @source)) if (@searchQuery.get('type').length == 0) or (@type in @searchQuery.get('type'))
    @

  apply: =>
    @searchQuery.setIncludeReplies(@$el.find("##{@source}_reply_include").get(0).checked, @source)
    @searchQuery.setExcludeReplies(@$el.find("##{@source}_reply_exclude").get(0).checked, @source)
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
